import React from "react";
import {
  Box, Card, Grid, CardContent, Divider, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter,
  Tab
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

  render() {
    const SupplyDebtInput = this.props.SupplyDebtInput;
    const SupplyDebtDetails = this.props.SupplyDebtDetails;
    const SearchData = this.props.SearchData;

    const totalBalance = SupplyDebtDetails.reduce((acc, group) => acc + (parseFloat(group.totalBalance) || 0), 0);

    return (
      <div style={{ backgroundColor: 'white', padding: '20px' }}>
        <h3><center><u>Supply Debt List Report 2</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>Group - {SearchData.groupName}</center></h4>
        <h4><center>Factory - {SearchData.factoryName}</center></h4>
        <h4><center>Route - {(SearchData.routeName === 0 || SearchData.routeName === null) ? "All Routes" : SearchData.routeName}</center></h4>
        <h4><center> Month - {SearchData.month}</center></h4>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer style={{ marginLeft: '5px' }}>
              <Table aria-label="caption table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align={'left'} style={{ border: "1px solid black", fontWeight: "bold", width: '150px', padding: '4px', height: '25px' }}>Registration Number</TableCell>
                    <TableCell align={'left'} style={{ border: "1px solid black", fontWeight: "bold", width: '200px', padding: '4px', height: '25px' }}>Customer Name</TableCell>
                    <TableCell align={'left'} style={{ border: "1px solid black", fontWeight: "bold", width: '150px', padding: '4px', height: '25px' }}>Last Month Crop (KG)</TableCell>
                    <TableCell align={'left'} style={{ border: "1px solid black", fontWeight: "bold", width: '150px', padding: '4px', height: '25px' }}>This Month Crop (KG)</TableCell>
                    <TableCell align={'left'} style={{ border: "1px solid black", fontWeight: "bold", width: '150px', padding: '4px', height: '25px' }}>Loan Balance (Rs.)</TableCell>
                    <TableCell align={'left'} style={{ border: "1px solid black", fontWeight: "bold", width: '150px', padding: '4px', height: '25px' }}>Last Month Debt (Rs.)</TableCell>
                    <TableCell align={'left'} style={{ border: "1px solid black", fontWeight: "bold", width: '150px', padding: '4px', height: '25px' }}>Last Month Balance (Rs.)</TableCell>
                    <TableCell align={'left'} style={{ border: "1px solid black", fontWeight: "bold", width: '150px', padding: '4px', height: '25px' }}>This Month Balance (Rs.)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {SupplyDebtDetails.map((group, index) => (
                    <React.Fragment key={index}>
                      <TableRow>
                        <TableCell
                          colSpan={8}
                          align="center"
                          style={{
                            fontWeight: "bold",
                            border: "1px solid black",
                            borderBottom: "none",
                            padding: '4px',
                            height: '25px'
                          }}
                        >
                          {group.routeName}
                        </TableCell>
                      </TableRow>

                      {group.records.map((rec, idx) => (
                        <TableRow key={`${index}-${idx}`}>
                          <TableCell align={'left'} style={{ border: "1px solid black", borderBottom: "none", padding: '4px', height: '20px' }}>
                            {rec.registrationNumber}
                          </TableCell>
                          <TableCell align={'left'} style={{ border: "1px solid black", borderBottom: "none", padding: '4px', height: '20px' }}>
                            {rec.name}
                          </TableCell>
                          <TableCell align={'right'} style={{ border: "1px solid black", borderBottom: "none", padding: '4px', height: '20px' }}>
                            {rec.lastMonthCropWeight}
                          </TableCell>
                          <TableCell align={'right'} style={{ border: "1px solid black", borderBottom: "none", padding: '4px', height: '20px' }}>
                            {rec.thisMonthCropWeight}
                          </TableCell>
                          <TableCell align={'right'} style={{ border: "1px solid black", borderBottom: "none", padding: '4px', height: '20px' }}>
                            {rec.loanTotal.toFixed(2)}
                          </TableCell>
                          <TableCell align={'right'} style={{ border: "1px solid black", borderBottom: "none", padding: '4px', height: '20px' }}>
                            {rec.debtAmount.toFixed(2)}
                          </TableCell>
                          <TableCell align={'right'} style={{ border: "1px solid black", borderBottom: "none", padding: '4px', height: '20px' }}>
                            {rec.lastMonthBalance.toFixed(2)}
                          </TableCell>
                          <TableCell align={'right'} style={{ border: "1px solid black", borderBottom: "none", padding: '4px', height: '20px' }}>
                            {rec.balance.toFixed(2)}
                          </TableCell>
                        </TableRow>
                      ))}

                      <TableRow>
                        <TableCell
                          colSpan={7}
                          align="left"
                          style={{
                            border: "1px solid black",
                            fontWeight: "bold",
                            padding: '4px',
                            height: '25px'
                          }}
                        >
                          Route Total: ({group.records.length})
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{
                            border: "1px solid black",
                            fontWeight: "bold",
                            padding: '4px',
                            height: '25px'
                          }}
                        >
                          {group.totalBalance.toFixed(2)}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          colSpan={8}
                          style={{
                            border: "none",
                            height: "5px",
                            padding: '0px'
                          }}
                        >
                          &nbsp;
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}

                  {SupplyDebtDetails.length > 1 && (
                    <TableRow>
                      <TableCell
                        colSpan={7}
                        align="left"
                        style={{
                          border: "1px solid black",
                          fontWeight: "bold",
                          padding: '4px',
                          height: '25px'
                        }}
                      >
                        Grand Total:
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          border: "1px solid black",
                          fontWeight: "bold",
                          padding: '4px',
                          height: '25px'
                        }}
                      >
                        {totalBalance.toFixed(2)}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
        <div>&nbsp;</div>
      </div>
    );
  }
}